export default "__VITE_ASSET__by$1B_hK__"